export default __webpack_public_path__ + "static/media/sticker-1F.6051eb26.png";